import {
  IDataAttributeMap,
  mapWithDataPrefix,
  ResponsiveTypography,
  ResponsiveTypographyVariant,
  TooltipPosition,
  withTheme,
} from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../../common/contexts';
import { IDiscountBadge } from '../DiscountBadge.interfaces';
import { DiscountBadgeTooltip } from '../DiscountBadgeTooltip';
import {
  DiscountPriceStyle,
  TextWrapper,
  TooltipStyle,
} from './../_Shared/discountBadgeShared.styles';
import { CustomDiscountBadgeSmallStyle, TextWrapperSmall } from './discountBadgeSmall.styles';

/**
 * A discount badge presented on sale card, can have two variands, depends on location on a sale card
 */
const DiscountBadgeSmall: React.FunctionComponent<Partial<IDiscountBadge>> = props => {
  const { showTooltip, discountPrice, theme, discountTooltip, dataAttributes } = props;

  const dataAttr: IDataAttributeMap = mapWithDataPrefix(dataAttributes);

  return (
    <TranslationsContext.Consumer>
      {({ translations }) => (
        <TextWrapper {...dataAttr}>
          <CustomDiscountBadgeSmallStyle>
            <TextWrapperSmall>
              <ResponsiveTypography
                variant={ResponsiveTypographyVariant.micro}
                color={theme.color.blackText}
              >
                {i18n('common.upTo.text', [], translations)}
              </ResponsiveTypography>
            </TextWrapperSmall>
            <DiscountPriceStyle {...props}>
              <ResponsiveTypography
                variant={ResponsiveTypographyVariant.t5SansBold}
                allowDangerousRender={true}
                color={theme.color.primary}
              >
                {discountPrice}
              </ResponsiveTypography>

              {showTooltip && (
                <TooltipStyle>
                  <DiscountBadgeTooltip
                    position={TooltipPosition.top}
                    discountTooltip={discountTooltip}
                  />
                </TooltipStyle>
              )}
            </DiscountPriceStyle>
          </CustomDiscountBadgeSmallStyle>
        </TextWrapper>
      )}
    </TranslationsContext.Consumer>
  );
};

export default withTheme(DiscountBadgeSmall);
